import { Component, Input } from '@angular/core';

@Component({
    selector: 'cpq-collapsible-section',
    templateUrl: './cpq-collapsible-section.component.html',
    styleUrl: './cpq-collapsible-section.component.scss',
    standalone: false
})

export class CpqCollapsibleSectionComponent {
  @Input() sectionTitle: string;
  @Input() sectionId: string;
  @Input() hasError: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() isToggled: boolean = true;

  public toggleSection(event) {
    const toggleElement = event.target;
    const contentElement = toggleElement.nextElementSibling;
    
    if (event.target.classList.contains('toggled')) {
      contentElement.style.maxHeight = contentElement.scrollHeight + "px";
      setTimeout(() => {
        contentElement.style.maxHeight = "none";
      }, 500);
    } else {
      contentElement.style.maxHeight = contentElement.scrollHeight + "px";
      setTimeout(() => {
        contentElement.style.maxHeight = "0";
      });
    }
    toggleElement.classList.toggle('toggled');
  }
}